(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonder-interactive-scan"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wonder-scan-demo')) {
    customElements.define('wonder-scan-demo', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-scan]');
        this.video = this.querySelector('video');
        this.endCard = this.querySelector('[data-end-card]');
        this.button.addEventListener('click', () => this.run());
        this.video?.addEventListener('ended', () => this.finishPreview());
        this.video?.addEventListener('timeupdate', () => {
          if (this.video.currentTime >= 10) this.finishPreview();
        });
      }
      finishPreview() {
        if (!this.video) return;
        this.video.pause();
        if (this.video.currentTime > 10) this.video.currentTime = 10;
        this.endCard.hidden = false;
        this.classList.add('is-ended');
        this.classList.remove('is-playing');
      }
      run() {
        window.clearTimeout(this.revealTimer);
        this.classList.remove('is-complete');
        this.classList.remove('is-playing');
        this.classList.remove('is-ended');
        this.endCard.hidden = true;
        if (this.video) {
          this.video.pause();
          this.video.currentTime = 0;
        }
        this.classList.add('is-scanning');
        this.button.disabled = true;
        window.setTimeout(() => {
          this.classList.remove('is-scanning');
          this.classList.add('is-complete');
          this.button.disabled = false;
          this.button.textContent = this.button.dataset.replay || 'Scan again';
          this.video?.play().catch(() => {});
          this.revealTimer = window.setTimeout(() => this.classList.add('is-playing'), 700);
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 80 : 1800);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonder-promo"] && !Shopify.designMode) return;
  try {
    
 if(!customElements.get('wonder-promo'))customElements.define('wonder-promo',class extends HTMLElement{
 connectedCallback(){const cycle=Math.max(1,Number(this.dataset.cycleMinutes)||120)*60*1000;const key='wonder-promo-cycle-end';const getEnd=()=>{let end=0;try{end=Number(localStorage.getItem(key));}catch(error){}if(!end||end<=Date.now()){end=Date.now()+cycle;try{localStorage.setItem(key,String(end));}catch(error){}}return end;};let end=getEnd();const tick=()=>{if(end<=Date.now())end=getEnd();const total=Math.max(0,Math.ceil((end-Date.now())/1000));this.querySelector('.wonder-promo__timer').hidden=false;const values={hours:Math.floor(total/3600),minutes:Math.floor(total%3600/60),seconds:total%60};Object.entries(values).forEach(([name,value])=>{const target=this.querySelector(`[data-${name}]`);if(target)target.textContent=String(value).padStart(2,'0');});};tick();this.timer=setInterval(tick,1000);}
 disconnectedCallback(){clearInterval(this.timer);}
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonder-welcome-popup"]) return;
  try {
    
  if(!customElements.get('wonder-welcome-popup'))customElements.define('wonder-welcome-popup',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();const opts={signal:this.controller.signal};
      this.dialog=this.querySelector('dialog');this.reopen=this.querySelector('[data-reopen]');
      this.key='wonder-welcome-dismissed-v1';this.state=this.querySelector('[data-form-state]').dataset.formState;
      this.isEditor=this.dataset.editor==='true';
      this.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>this.dialog.close(),opts));
      this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('wwp-open');this.remember();this.reopen.hidden=false;},opts);
      this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();},opts);
      this.reopen.addEventListener('click',()=>this.show(),opts);
      this.querySelector('[data-copy]')?.addEventListener('click',()=>this.copy(),opts);
      document.addEventListener('shopify:section:select',event=>{if(this.isEditor&&this.dataset.editorPreview==='true'&&event.target.contains(this))this.show();},opts);
      if(this.isEditor){this.reopen.hidden=false;}
      else if(this.state==='success'||this.state==='error'){if(this.state==='success')this.remember();this.show();}
      else if(this.dismissed()){this.reopen.hidden=false;}
      else this.timer=setTimeout(()=>this.showWhenReady(),Math.max(0,Number(this.dataset.delay)||5)*1000);
    }
    dismissed(){for(const name of ['localStorage','sessionStorage']){try{if(Number(window[name].getItem(this.key))>Date.now())return true;}catch{}}try{const prefix=encodeURIComponent(this.key)+'=';const saved=document.cookie.split(';').map(value=>value.trim()).find(value=>value.startsWith(prefix));if(saved&&Number(saved.slice(prefix.length))>Date.now())return true;}catch{}return false;}
    remember(){if(this.isEditor)return;const seconds=Math.max(1,Number(this.dataset.days)||30)*86400;const until=String(Date.now()+seconds*1000);for(const name of ['localStorage','sessionStorage']){try{window[name].setItem(this.key,until);}catch{}}try{document.cookie=encodeURIComponent(this.key)+'='+until+'; Max-Age='+seconds+'; Path=/; SameSite=Lax; Secure';}catch{}}
    showWhenReady(){if(!this.isConnected)return;if(this.dismissed()){this.reopen.hidden=false;return;}if(document.hidden||document.querySelector('dialog[open]')){this.timer=setTimeout(()=>this.showWhenReady(),1000);return;}this.show();}
    show(){if(this.dialog.open)return;clearTimeout(this.timer);this.dialog.showModal();this.remember();document.documentElement.classList.add('wwp-open');this.reopen.hidden=true;}
    async copy(){const input=this.querySelector('[data-code]'),status=this.querySelector('[data-status]');try{await navigator.clipboard.writeText(input.value);status.textContent=this.dataset.copied;}catch{input.focus();input.select();status.textContent=this.dataset.copyFailed;}}
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.controller=null;if(this.dialog?.open){this.dialog.close();document.documentElement.classList.remove('wwp-open');}}
  });

  } catch(e) { console.error(e); }
})();
})();
